import { render, staticRenderFns } from "./ModalChatUserInfo.vue?vue&type=template&id=1e229262&scoped=true&"
import script from "./ModalChatUserInfo.vue?vue&type=script&lang=js&"
export * from "./ModalChatUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalChatUserInfo.vue?vue&type=style&index=0&id=1e229262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e229262",
  null
  
)

export default component.exports